(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Book-lists-section"] && !Shopify.designMode) return;
  try {
    
  /* ---------- Collection filter bar (multi-select) ---------- */

  function initFilterBar() {
    const buttons = document.querySelectorAll('.book-lists-filter-btn');
    const items = document.querySelectorAll('.book-lists-item');
    const allBtn = document.querySelector('.book-lists-filter-btn[data-filter-name="all"]');

    function applyFilters() {
      const activeButtons = Array.from(buttons).filter(
        (b) => b !== allBtn && b.classList.contains('is-active')
      );

      const showAll = activeButtons.length === 0;

      if (showAll) {
        allBtn.classList.add('is-active');
      } else {
        allBtn.classList.remove('is-active');
      }

      const shopifyOnlyActive = activeButtons.some(
        (b) => b.dataset.filterName === '__shopify_collections__'
      );

      const namedActive = activeButtons
        .filter((b) => b.dataset.filterName !== '__shopify_collections__')
        .map((b) => b.dataset.filterName);

      items.forEach((item) => {
        let matches = showAll;

        if (!matches && shopifyOnlyActive && item.dataset.blockType === 'collection') {
          matches = true;
        }

        if (!matches && namedActive.includes(item.dataset.filterName)) {
          matches = true;
        }

        item.classList.toggle('is-hidden', !matches);
      });

      updateCarouselCardSizing();
      document.querySelectorAll('.custom-carousel-wrapper').forEach(updateCarouselArrows);
    }

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn === allBtn) {
          buttons.forEach((b) => b.classList.remove('is-active'));
          allBtn.classList.add('is-active');
        } else {
          btn.classList.toggle('is-active');
        }

        applyFilters();
      });
    });
  }

  /* ---------- Collection carousel behavior ---------- */

  function updateCarouselArrows(wrapper) {
    const track = wrapper.querySelector('.custom-collection-carousel');
    const prevBtn = wrapper.querySelector('.custom-carousel-arrow--prev');
    const nextBtn = wrapper.querySelector('.custom-carousel-arrow--next');

    const isScrollable = track.scrollWidth > track.clientWidth + 1;
    prevBtn.style.display = isScrollable ? '' : 'none';
    nextBtn.style.display = isScrollable ? '' : 'none';

    if (isScrollable) {
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    }
  }

  function initCarousels() {
    document.querySelectorAll('.custom-carousel-wrapper').forEach(function (wrapper) {
      updateCarouselArrows(wrapper);

      const track = wrapper.querySelector('.custom-collection-carousel');
      track.addEventListener('scroll', function () {
        updateCarouselArrows(wrapper);
      });
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.custom-carousel-arrow');
    if (!btn) return;

    const wrapper = btn.closest('.custom-carousel-wrapper');
    const track = wrapper.querySelector('.custom-collection-carousel');
    const scrollAmount = track.clientWidth * 0.8;

    track.scrollBy({
      left: btn.classList.contains('custom-carousel-arrow--next') ? scrollAmount : -scrollAmount,
      behavior: 'smooth'
    });
  });

  /* ---------- Hash scroll-to-card on load ---------- */

  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* ---------- Card sizing per view ---------- */

  function updateCarouselCardSizing() {
    document.querySelectorAll('.custom-carousel-wrapper').forEach((wrapper) => {

      const track = wrapper.querySelector('.custom-collection-carousel');
      if (!track) return;

      const containerWidth = track.clientWidth;
      if (!containerWidth) return;

      const cards = Array.from(
        track.querySelectorAll('.custom-collection-product')
      );

      if (!cards.length) return;

      /*
       * Get the actual CSS gap.
       */
      const styles = window.getComputedStyle(track);
      const gap =
        parseFloat(styles.columnGap) ||
        parseFloat(styles.gap) ||
        0;

      /*
       * Minimum width for a complete product card.
       * Adjust this to control how many cards show per view.
       */
      const minCardWidth = 180;

      /*
       * Calculate how many COMPLETE cards fit in one view.
       */
      let cardsPerView = Math.floor(
        (containerWidth + gap) /
        (minCardWidth + gap)
      );

      cardsPerView = Math.max(1, cardsPerView);
      cardsPerView = Math.min(cardsPerView, cards.length);

      /*
       * Calculate exact width so `cardsPerView` cards fill the row.
       */
      const totalGapWidth = gap * (cardsPerView - 1);
      const cardWidth = (containerWidth - totalGapWidth) / cardsPerView;

      /*
       * Apply sizing to every card (none are hidden — the rest
       * remain scrollable off to the side).
       */
      cards.forEach((card) => {
        card.style.width = `${cardWidth}px`;
        card.style.minWidth = `${cardWidth}px`;
        card.style.maxWidth = `${cardWidth}px`;
        card.style.flex = `0 0 ${cardWidth}px`;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initCarousels();
    initFilterBar();
    updateCarouselCardSizing();
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.custom-carousel-wrapper').forEach(updateCarouselArrows);
    updateCarouselCardSizing();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  const images = document.querySelectorAll('.mw-image-gallery a');
  const modal = document.querySelector('.mw-modal');
  const modalImage = modal.querySelector('img');
  let currentIndex = 0;
  
  // Open modal popup and show clicked image
  function showModal(index) {
    if(window.innerWidth > 749){
      modalImage.src = images[index].dataset.desktop;
    } else {
      modalImage.src = images[index].dataset.mobile;  
    }    
    modal.classList.add('show');
    currentIndex = index;
  }
  
  // Hide modal popup
  function hideModal() {
    modal.classList.remove('show');
  }
  
  // Show previous image in gallery
  function showPrevImage(e) {
    e.stopPropagation()
    if (currentIndex === 0) {
      showModal(images.length - 1);
    } else {
      showModal(currentIndex - 1);
    }
  }
  
  // Show next image in gallery
  function showNextImage(e) {
    e.stopPropagation()
    if (currentIndex === images.length - 1) {
      showModal(0);
    } else {
      showModal(currentIndex + 1);
    }
  }
  
  // Add click event listeners to all images
  images.forEach((image, index) => {
    image.addEventListener('click', (e) => {
      e.preventDefault()
      showModal(index);
    });
  });  
    
  // Add click event listeners to modal navigation arrows
  const prevArrow = modal.querySelector('.mw-modal-prev');
  prevArrow.addEventListener('click', showPrevImage);
  
  const nextArrow = modal.querySelector('.mw-modal-next');
  nextArrow.addEventListener('click', showNextImage);
  
  // Add click event listener to modal background to hide it
  modal.addEventListener('click', hideModal);

  
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
